import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'awair-create-organization-form',
  templateUrl: './create-organization-form.component.html',
  styleUrls: ['./create-organization-form.component.scss']
})

export class CreateOrganizationFormComponent implements OnInit {

  @Input() isOrganizationCreating: boolean = false;
  @Input() isOrganizationCreated: boolean = false;
  @Input() errorMessage: string;
  @Output() createOrganization: EventEmitter<{organizationName: string}> = new EventEmitter<{organizationName: string}>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  form: FormGroup = new FormGroup({
    organizationName: new FormControl({value: '', disabled: this.isOrganizationCreating}, [
      Validators.required,
      Validators.minLength(1)
    ]),
  });

  constructor() {
  }

  ngOnInit() {
  }

  onCreateOrganization(): void {
    if (this.form.valid) {
      this.createOrganization.emit(this.form.value);
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
